var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { addTicketsToBasket, addToMultiTicketSelection } from "../store/seatmap";
import { useTranslation } from 'react-i18next';
var isClickedInside = function (e, element) {
    var node = e.target;
    while (node) {
        if (node === element) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
};
var FeeLabel = function (_a) {
    var feesValue = _a.feesValue, inclusive = _a.inclusive, feesTitle = _a.feesTitle;
    if (feesValue === undefined || inclusive === undefined || feesTitle === "") {
        return null;
    }
    var feeString = inclusive ? " inc ".concat(feesValue, " fee") : " + ".concat(feesValue, " fee");
    return (_jsx("p", __assign({ className: "small-grey-text centre-fees-text-absolutely" }, { children: feeString })));
};
var Popup = function (_a) {
    var position = _a.position, seat = _a.seat, priceBand = _a.priceBand, onClose = _a.onClose;
    var actualX = (position.x + 360 > window.innerWidth) ? 0 : position.x;
    var _b = useState({}), promoCode = _b[0], setPromoCode = _b[1];
    var dispatch = useDispatch();
    var containerRef = React.useRef(null);
    var _c = useTranslation(), t = _c.t, i18n = _c.i18n;
    React.useEffect(function () {
        var onClick = function (e) {
            if (!isClickedInside(e, containerRef.current)) {
                onClose();
            }
        };
        setTimeout(function () { return window.addEventListener("click", onClick); }, 20);
        return function () {
            window.removeEventListener("click", onClick);
        };
    }, []);
    var handleOnSelect = function (concessionId, multi) {
        if (concessionId === void 0) { concessionId = "0"; }
        if (multi === void 0) { multi = false; }
        var selection = {
            seatId: seat.id,
            priceBandId: priceBand.id,
            concessionId: concessionId,
            promoCode: (!promoCode[concessionId] ? undefined : promoCode[concessionId])
        };
        if (multi) {
            dispatch(addToMultiTicketSelection(selection));
        }
        else {
            dispatch(addTicketsToBasket({ ticketSelections: [selection] }));
        }
        onClose();
    };
    return (_jsxs("div", __assign({ ref: containerRef, style: {
            top: position.y + 5 + "px",
            left: actualX + "px",
            position: 'absolute',
            zIndex: 1000
        }, className: "popover-body" }, { children: [_jsx("div", __assign({ className: "popover-seat" }, { children: _jsxs("ul", { children: [_jsxs("li", { children: [t('Seat'), " ", _jsx("span", { children: seat.number })] }), _jsxs("li", { children: [t('Row'), " ", _jsx("span", { children: seat.row })] }), _jsxs("li", { children: [t('Block'), " ", _jsx("span", { children: seat.block })] })] }) })), _jsxs("div", __assign({ className: "select-ticket" }, { children: [_jsx("h3", { children: t('Select ticket type') }), priceBand.concessions.map(function (_a, index) {
                        var _b;
                        var title = _a.title, description = _a.description, price = _a.price, id = _a.id, minimumQty = _a.minimumQty, feesTitle = _a.feesTitle, feesValue = _a.feesValue, inclusiveFees = _a.inclusiveFees, isPromoCodeRequired = _a.isPromoCodeRequired;
                        var multiMode = minimumQty > 1;
                        return (_jsxs("ul", { children: [_jsxs("li", __assign({ className: "price-title tooltip-container" }, { children: [_jsxs("span", __assign({ className: "title-and-tooltip-wrapper position-relative" }, { children: [_jsxs("div", __assign({ className: "display-flex" }, { children: [t(title), description ? _jsx("p", __assign({ className: "tooltip-icon" }, { children: " \u24D8 " })) : null] })), isPromoCodeRequired ?
                                                    _jsx("div", { children: _jsx("input", { placeholder: t('Promo code'), value: (_b = promoCode[id]) !== null && _b !== void 0 ? _b : "", "data-testid": "promo-code-input", name: "promocode", onChange: function (evt) { return setPromoCode(function (codes) {
                                                                var _a;
                                                                return (__assign(__assign({}, codes), (_a = {}, _a[id] = evt.target.value, _a)));
                                                            }); }, className: "promo-code-input", type: "text" }) }) : null] })), description ?
                                            _jsx("span", __assign({ className: isPromoCodeRequired ? "tooltiptext tooltiptext-with-input" : "tooltiptext" }, { children: t(description) })) : null] })), feesValue ? _jsxs("li", __assign({ className: "price-popover-col position-lower" }, { children: [_jsx("p", { children: price }), _jsx(FeeLabel, { feesValue: feesValue, feesTitle: feesTitle, inclusive: inclusiveFees })] })) :
                                    _jsxs("li", __assign({ className: "price-popover-col" }, { children: [_jsx("p", { children: price }), _jsx(FeeLabel, { feesValue: feesValue, feesTitle: feesTitle, inclusive: inclusiveFees })] })), _jsx("li", { children: multiMode ? (_jsxs("button", __assign({ "data-testid": "popover-add-to-basket", onClick: function () { return handleOnSelect(id, true); } }, { children: [t('Add'), " ", minimumQty, " ", t('seats')] }))) : (_jsxs(_Fragment, { children: [_jsxs("button", __assign({ "data-testid": "popover-add-to-basket", onClick: function () { return handleOnSelect(id); } }, { children: [t('Add'), " "] })), " ", _jsxs("button", __assign({ onClick: function () { return handleOnSelect(id, true); } }, { children: [t('Add Multiple'), " "] }))] })) })] }, index));
                    })] }))] })));
};
export default Popup;
